import { useCallback, useMemo, useState } from 'react';
import { getJsonItem, setJsonItem } from 'util/localStorage';

const STORAGE_KEY_BASE = 'UTILIHIVE:';

const useLocalStorageState = (name, defaultValue) => {
  const key = useMemo(() => STORAGE_KEY_BASE + name, [name]);
  const [value, setValue] = useState(getJsonItem(key) === null ? defaultValue : getJsonItem(key));
  const setStoredValue = useCallback(
    valueOrCallback => {
      if (typeof valueOrCallback === 'function') {
        const newValue = valueOrCallback(value);
        setJsonItem(key, newValue);
        setValue(newValue);
      } else {
        setJsonItem(key, valueOrCallback);
        setValue(valueOrCallback);
      }
    },
    [value, key]
  );
  return useMemo(() => [value, setStoredValue], [value, setStoredValue]);
};

export default useLocalStorageState;
